import {
  Box,
  Card,
  Typography,
  Container,
  Button,
  styled
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../contexts/authContext';

const MainContent = styled(Box)(
  () => `
      height: 100%;
      display: flex;
      flex: 1;
      overflow: auto;
      flex-direction: column;
      align-items: center;
      justify-content: center;
  `
);


function AccessDenied() {
  const { user, logout } = useAuth();
  return (
    <>
      <Helmet>
        <title>Access-Denied</title>
      </Helmet>
      <MainContent>
        <Container maxWidth="md">
          <Box textAlign="center">
            <img alt="404" height={400} src="/static/images/coe-banner.png" />
            <Typography
              variant="h2"
              sx={{
                my: 2
              }}
            >
              {'You account approval is still pending.'}
            </Typography>
            <Typography
              variant="h4"
              color="text.secondary"
              fontWeight="normal"
              sx={{
                mb: 4
              }}
            >
              {
                'If you signed up recently, we are currently reviewing your profile, please visit after sometime.'
              }
            </Typography>
          </Box>
          <Container maxWidth="sm">
            <Card
              sx={{
                textAlign: 'center',
                mt: 3,
                p: 4
              }}
            >
              <Button href="/" variant="outlined">
                {'Go to CIRA App'}
              </Button>
              <Button sx={{ ml: 4 }} onClick={logout} variant="outlined">
                {'Log out'}
              </Button>
            </Card>
          </Container>
        </Container>
      </MainContent>
    </>
  );
}

export default AccessDenied;
